// Core/PainterRegistry.js
// Singleton — same pattern as commandEngine.registerXxxCommand (module-load registration).
// Jerny stays domain-agnostic: only knows "key -> painter component", never crypto/power concepts.
class PainterRegistry {
  constructor() {
    this._map = new Map();
  }

  /**
   * Register a painter component for a given key.
   * @param {string} key - e.g. "CryptoDataProducer:v1"
   * @param {React.ComponentType} painterComponent
   */
  register(key, painterComponent) {
    this._map.set(key, painterComponent);
  }

  /**
   * Resolve a painter component for a given key.
   * @param {string} key
   * @returns {React.ComponentType|null}
   */
  resolve(key) {
    return this._map.get(key) || null;
  }
}

const painterRegistry = new PainterRegistry();
export default painterRegistry;
